import { useState, useEffect, useCallback } from "react";

import makeStyles from "styles/muiStylesCompat/makeStyles";
import { useParams } from "react-router-dom";

import Paper from "@mui/material/Paper";

import SpinnerCentered from "~/components/Loader/SpinnerCentered";
import { httpGetOrder } from "~/services/http/orders";
import OrderDetail from "~/components/OrderDetail";

const useStyles = makeStyles((theme) => ({
  overrides: {
    MuiTableCell: {
      root: {
        fontWeight: "bold",
        backgroundColor: "lightblue",
        "&:last-child": {
          paddingRight: 5,
        },
      },
    },
  },
  content: {
    padding: 48,
    overflowX: "auto",
  },
  title: {
    paddingBottom: 32,
  },
  table: {
    minWidth: 650,
    borderWidth: 1,
    borderColor: theme.palette.table.border,
    borderStyle: "solid",
    fontSize: 16,
    fontWeight: "bold",
  },
  tableHeaderCell: {
    color: theme.palette.table.thead.text,
    fontSize: 16,
    fontWeight: "bold",
    backgroundColor: theme.palette.table.thead.background,
  },
  logo: {
    width: 24,
    height: 24,
    marginLeft: 2,
  },
  notConfirmed: {
    color: "#B5B5B5",
  },
  confirmed: {
    color: "#87CC72",
  },
  filter: {
    padding: "16px",
  },
}));

const OrderDetailView = (_props) => {
  const classes = useStyles();
  const { orderId } = useParams();

  const [order, setOrder] = useState();
  const [loading, setLoading] = useState(true);

  const getOrder = useCallback(() => {
    setLoading(true);
    const request = {
      params: {
        completed: true,
      },
    };

    httpGetOrder(request, orderId).then((response) => {
      setOrder(response);
      setLoading(false);
    });
  }, [orderId]);

  useEffect(() => {
    getOrder();
  }, [orderId, getOrder]);

  return (
    <Paper className={classes.content} elevation={0} square>
      {loading ? <SpinnerCentered /> : <OrderDetail order={order} />}
    </Paper>
  );
};

export default OrderDetailView;
